export default __webpack_public_path__ + "static/media/Kvalitet.a39cd2fe.jpg";